// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ZakatCalculatorRouteImport } from './routes/zakat-calculator'
import { Route as YearCalculatorRouteImport } from './routes/year-calculator'
import { Route as WhyRouteImport } from './routes/why'
import { Route as VatCalculatorRouteImport } from './routes/vat-calculator'
import { Route as UnitConverterRouteImport } from './routes/unit-converter'
import { Route as TimeCalculatorRouteImport } from './routes/time-calculator'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TaxCalculatorRouteImport } from './routes/tax-calculator'
import { Route as SquareFeetCalculatorRouteImport } from './routes/square-feet-calculator'
import { Route as SehriIftarTimeRouteImport } from './routes/sehri-iftar-time'
import { Route as ScientificCalculatorRouteImport } from './routes/scientific-calculator'
import { Route as QuadraticFormulaSolverRouteImport } from './routes/quadratic-formula-solver'
import { Route as QiblaDirectionRouteImport } from './routes/qibla-direction'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PrayerTimesRouteImport } from './routes/prayer-times'
import { Route as PercentageCalculatorRouteImport } from './routes/percentage-calculator'
import { Route as MonthCalculatorRouteImport } from './routes/month-calculator'
import { Route as MathSolverRouteImport } from './routes/math-solver'
import { Route as LoanCalculatorRouteImport } from './routes/loan-calculator'
import { Route as LandCalculatorRouteImport } from './routes/land-calculator'
import { Route as KgToPoundsRouteImport } from './routes/kg-to-pounds'
import { Route as InterestCalculatorRouteImport } from './routes/interest-calculator'
import { Route as IntegralCalculatorRouteImport } from './routes/integral-calculator'
import { Route as HoursCalculatorRouteImport } from './routes/hours-calculator'
import { Route as HijriDateConverterRouteImport } from './routes/hijri-date-converter'
import { Route as HeightCalculatorRouteImport } from './routes/height-calculator'
import { Route as GraphingCalculatorRouteImport } from './routes/graphing-calculator'
import { Route as GpaCalculatorRouteImport } from './routes/gpa-calculator'
import { Route as GbpToUsdRouteImport } from './routes/gbp-to-usd'
import { Route as FeetToMeterRouteImport } from './routes/feet-to-meter'
import { Route as FaraidCalculatorRouteImport } from './routes/faraid-calculator'
import { Route as EmiCalculatorRouteImport } from './routes/emi-calculator'
import { Route as DutyCalculatorRouteImport } from './routes/duty-calculator'
import { Route as DistanceCalculatorRouteImport } from './routes/distance-calculator'
import { Route as DiscountCalculatorRouteImport } from './routes/discount-calculator'
import { Route as DaysCalculatorRouteImport } from './routes/days-calculator'
import { Route as DateCalculatorRouteImport } from './routes/date-calculator'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CompoundInterestCalculatorRouteImport } from './routes/compound-interest-calculator'
import { Route as CmToFeetRouteImport } from './routes/cm-to-feet'
import { Route as CasioFx991exRouteImport } from './routes/casio-fx-991ex'
import { Route as CasioFx991esRouteImport } from './routes/casio-fx-991es'
import { Route as CasioCalculatorRouteImport } from './routes/casio-calculator'
import { Route as CalorieCalculatorRouteImport } from './routes/calorie-calculator'
import { Route as BraSizeCalculatorRouteImport } from './routes/bra-size-calculator'
import { Route as BodyTypeCalculatorRouteImport } from './routes/body-type-calculator'
import { Route as BodyShapeCalculatorRouteImport } from './routes/body-shape-calculator'
import { Route as BodyFatCalculatorRouteImport } from './routes/body-fat-calculator'
import { Route as BmrCalculatorRouteImport } from './routes/bmr-calculator'
import { Route as BmiCalculatorRouteImport } from './routes/bmi-calculator'
import { Route as BinaryCalculatorRouteImport } from './routes/binary-calculator'
import { Route as AspectRatioCalculatorRouteImport } from './routes/aspect-ratio-calculator'
import { Route as AgeCalculatorRouteImport } from './routes/age-calculator'
import { Route as AboutRouteImport } from './routes/about'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as IndexRouteImport } from './routes/index'

const ZakatCalculatorRoute = ZakatCalculatorRouteImport.update({
            id: '/zakat-calculator',path: '/zakat-calculator',getParentRoute: () => rootRouteImport
          })
const YearCalculatorRoute = YearCalculatorRouteImport.update({
            id: '/year-calculator',path: '/year-calculator',getParentRoute: () => rootRouteImport
          })
const WhyRoute = WhyRouteImport.update({
            id: '/why',path: '/why',getParentRoute: () => rootRouteImport
          })
const VatCalculatorRoute = VatCalculatorRouteImport.update({
            id: '/vat-calculator',path: '/vat-calculator',getParentRoute: () => rootRouteImport
          })
const UnitConverterRoute = UnitConverterRouteImport.update({
            id: '/unit-converter',path: '/unit-converter',getParentRoute: () => rootRouteImport
          })
const TimeCalculatorRoute = TimeCalculatorRouteImport.update({
            id: '/time-calculator',path: '/time-calculator',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TaxCalculatorRoute = TaxCalculatorRouteImport.update({
            id: '/tax-calculator',path: '/tax-calculator',getParentRoute: () => rootRouteImport
          })
const SquareFeetCalculatorRoute = SquareFeetCalculatorRouteImport.update({
            id: '/square-feet-calculator',path: '/square-feet-calculator',getParentRoute: () => rootRouteImport
          })
const SehriIftarTimeRoute = SehriIftarTimeRouteImport.update({
            id: '/sehri-iftar-time',path: '/sehri-iftar-time',getParentRoute: () => rootRouteImport
          })
const ScientificCalculatorRoute = ScientificCalculatorRouteImport.update({
            id: '/scientific-calculator',path: '/scientific-calculator',getParentRoute: () => rootRouteImport
          })
const QuadraticFormulaSolverRoute = QuadraticFormulaSolverRouteImport.update({
            id: '/quadratic-formula-solver',path: '/quadratic-formula-solver',getParentRoute: () => rootRouteImport
          })
const QiblaDirectionRoute = QiblaDirectionRouteImport.update({
            id: '/qibla-direction',path: '/qibla-direction',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PrayerTimesRoute = PrayerTimesRouteImport.update({
            id: '/prayer-times',path: '/prayer-times',getParentRoute: () => rootRouteImport
          })
const PercentageCalculatorRoute = PercentageCalculatorRouteImport.update({
            id: '/percentage-calculator',path: '/percentage-calculator',getParentRoute: () => rootRouteImport
          })
const MonthCalculatorRoute = MonthCalculatorRouteImport.update({
            id: '/month-calculator',path: '/month-calculator',getParentRoute: () => rootRouteImport
          })
const MathSolverRoute = MathSolverRouteImport.update({
            id: '/math-solver',path: '/math-solver',getParentRoute: () => rootRouteImport
          })
const LoanCalculatorRoute = LoanCalculatorRouteImport.update({
            id: '/loan-calculator',path: '/loan-calculator',getParentRoute: () => rootRouteImport
          })
const LandCalculatorRoute = LandCalculatorRouteImport.update({
            id: '/land-calculator',path: '/land-calculator',getParentRoute: () => rootRouteImport
          })
const KgToPoundsRoute = KgToPoundsRouteImport.update({
            id: '/kg-to-pounds',path: '/kg-to-pounds',getParentRoute: () => rootRouteImport
          })
const InterestCalculatorRoute = InterestCalculatorRouteImport.update({
            id: '/interest-calculator',path: '/interest-calculator',getParentRoute: () => rootRouteImport
          })
const IntegralCalculatorRoute = IntegralCalculatorRouteImport.update({
            id: '/integral-calculator',path: '/integral-calculator',getParentRoute: () => rootRouteImport
          })
const HoursCalculatorRoute = HoursCalculatorRouteImport.update({
            id: '/hours-calculator',path: '/hours-calculator',getParentRoute: () => rootRouteImport
          })
const HijriDateConverterRoute = HijriDateConverterRouteImport.update({
            id: '/hijri-date-converter',path: '/hijri-date-converter',getParentRoute: () => rootRouteImport
          })
const HeightCalculatorRoute = HeightCalculatorRouteImport.update({
            id: '/height-calculator',path: '/height-calculator',getParentRoute: () => rootRouteImport
          })
const GraphingCalculatorRoute = GraphingCalculatorRouteImport.update({
            id: '/graphing-calculator',path: '/graphing-calculator',getParentRoute: () => rootRouteImport
          })
const GpaCalculatorRoute = GpaCalculatorRouteImport.update({
            id: '/gpa-calculator',path: '/gpa-calculator',getParentRoute: () => rootRouteImport
          })
const GbpToUsdRoute = GbpToUsdRouteImport.update({
            id: '/gbp-to-usd',path: '/gbp-to-usd',getParentRoute: () => rootRouteImport
          })
const FeetToMeterRoute = FeetToMeterRouteImport.update({
            id: '/feet-to-meter',path: '/feet-to-meter',getParentRoute: () => rootRouteImport
          })
const FaraidCalculatorRoute = FaraidCalculatorRouteImport.update({
            id: '/faraid-calculator',path: '/faraid-calculator',getParentRoute: () => rootRouteImport
          })
const EmiCalculatorRoute = EmiCalculatorRouteImport.update({
            id: '/emi-calculator',path: '/emi-calculator',getParentRoute: () => rootRouteImport
          })
const DutyCalculatorRoute = DutyCalculatorRouteImport.update({
            id: '/duty-calculator',path: '/duty-calculator',getParentRoute: () => rootRouteImport
          })
const DistanceCalculatorRoute = DistanceCalculatorRouteImport.update({
            id: '/distance-calculator',path: '/distance-calculator',getParentRoute: () => rootRouteImport
          })
const DiscountCalculatorRoute = DiscountCalculatorRouteImport.update({
            id: '/discount-calculator',path: '/discount-calculator',getParentRoute: () => rootRouteImport
          })
const DaysCalculatorRoute = DaysCalculatorRouteImport.update({
            id: '/days-calculator',path: '/days-calculator',getParentRoute: () => rootRouteImport
          })
const DateCalculatorRoute = DateCalculatorRouteImport.update({
            id: '/date-calculator',path: '/date-calculator',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CompoundInterestCalculatorRoute = CompoundInterestCalculatorRouteImport.update({
            id: '/compound-interest-calculator',path: '/compound-interest-calculator',getParentRoute: () => rootRouteImport
          })
const CmToFeetRoute = CmToFeetRouteImport.update({
            id: '/cm-to-feet',path: '/cm-to-feet',getParentRoute: () => rootRouteImport
          })
const CasioFx991exRoute = CasioFx991exRouteImport.update({
            id: '/casio-fx-991ex',path: '/casio-fx-991ex',getParentRoute: () => rootRouteImport
          })
const CasioFx991esRoute = CasioFx991esRouteImport.update({
            id: '/casio-fx-991es',path: '/casio-fx-991es',getParentRoute: () => rootRouteImport
          })
const CasioCalculatorRoute = CasioCalculatorRouteImport.update({
            id: '/casio-calculator',path: '/casio-calculator',getParentRoute: () => rootRouteImport
          })
const CalorieCalculatorRoute = CalorieCalculatorRouteImport.update({
            id: '/calorie-calculator',path: '/calorie-calculator',getParentRoute: () => rootRouteImport
          })
const BraSizeCalculatorRoute = BraSizeCalculatorRouteImport.update({
            id: '/bra-size-calculator',path: '/bra-size-calculator',getParentRoute: () => rootRouteImport
          })
const BodyTypeCalculatorRoute = BodyTypeCalculatorRouteImport.update({
            id: '/body-type-calculator',path: '/body-type-calculator',getParentRoute: () => rootRouteImport
          })
const BodyShapeCalculatorRoute = BodyShapeCalculatorRouteImport.update({
            id: '/body-shape-calculator',path: '/body-shape-calculator',getParentRoute: () => rootRouteImport
          })
const BodyFatCalculatorRoute = BodyFatCalculatorRouteImport.update({
            id: '/body-fat-calculator',path: '/body-fat-calculator',getParentRoute: () => rootRouteImport
          })
const BmrCalculatorRoute = BmrCalculatorRouteImport.update({
            id: '/bmr-calculator',path: '/bmr-calculator',getParentRoute: () => rootRouteImport
          })
const BmiCalculatorRoute = BmiCalculatorRouteImport.update({
            id: '/bmi-calculator',path: '/bmi-calculator',getParentRoute: () => rootRouteImport
          })
const BinaryCalculatorRoute = BinaryCalculatorRouteImport.update({
            id: '/binary-calculator',path: '/binary-calculator',getParentRoute: () => rootRouteImport
          })
const AspectRatioCalculatorRoute = AspectRatioCalculatorRouteImport.update({
            id: '/aspect-ratio-calculator',path: '/aspect-ratio-calculator',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorRoute = AgeCalculatorRouteImport.update({
            id: '/age-calculator',path: '/age-calculator',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SlugRoute: SlugRoute,AboutRoute: AboutRoute,AgeCalculatorRoute: AgeCalculatorRoute,AspectRatioCalculatorRoute: AspectRatioCalculatorRoute,BinaryCalculatorRoute: BinaryCalculatorRoute,BmiCalculatorRoute: BmiCalculatorRoute,BmrCalculatorRoute: BmrCalculatorRoute,BodyFatCalculatorRoute: BodyFatCalculatorRoute,BodyShapeCalculatorRoute: BodyShapeCalculatorRoute,BodyTypeCalculatorRoute: BodyTypeCalculatorRoute,BraSizeCalculatorRoute: BraSizeCalculatorRoute,CalorieCalculatorRoute: CalorieCalculatorRoute,CasioCalculatorRoute: CasioCalculatorRoute,CasioFx991esRoute: CasioFx991esRoute,CasioFx991exRoute: CasioFx991exRoute,CmToFeetRoute: CmToFeetRoute,CompoundInterestCalculatorRoute: CompoundInterestCalculatorRoute,ContactRoute: ContactRoute,DateCalculatorRoute: DateCalculatorRoute,DaysCalculatorRoute: DaysCalculatorRoute,DiscountCalculatorRoute: DiscountCalculatorRoute,DistanceCalculatorRoute: DistanceCalculatorRoute,DutyCalculatorRoute: DutyCalculatorRoute,EmiCalculatorRoute: EmiCalculatorRoute,FaraidCalculatorRoute: FaraidCalculatorRoute,FeetToMeterRoute: FeetToMeterRoute,GbpToUsdRoute: GbpToUsdRoute,GpaCalculatorRoute: GpaCalculatorRoute,GraphingCalculatorRoute: GraphingCalculatorRoute,HeightCalculatorRoute: HeightCalculatorRoute,HijriDateConverterRoute: HijriDateConverterRoute,HoursCalculatorRoute: HoursCalculatorRoute,IntegralCalculatorRoute: IntegralCalculatorRoute,InterestCalculatorRoute: InterestCalculatorRoute,KgToPoundsRoute: KgToPoundsRoute,LandCalculatorRoute: LandCalculatorRoute,LoanCalculatorRoute: LoanCalculatorRoute,MathSolverRoute: MathSolverRoute,MonthCalculatorRoute: MonthCalculatorRoute,PercentageCalculatorRoute: PercentageCalculatorRoute,PrayerTimesRoute: PrayerTimesRoute,PrivacyRoute: PrivacyRoute,QiblaDirectionRoute: QiblaDirectionRoute,QuadraticFormulaSolverRoute: QuadraticFormulaSolverRoute,ScientificCalculatorRoute: ScientificCalculatorRoute,SehriIftarTimeRoute: SehriIftarTimeRoute,SquareFeetCalculatorRoute: SquareFeetCalculatorRoute,TaxCalculatorRoute: TaxCalculatorRoute,TermsRoute: TermsRoute,TimeCalculatorRoute: TimeCalculatorRoute,UnitConverterRoute: UnitConverterRoute,VatCalculatorRoute: VatCalculatorRoute,WhyRoute: WhyRoute,YearCalculatorRoute: YearCalculatorRoute,ZakatCalculatorRoute: ZakatCalculatorRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)